module.exports = __webpack_public_path__ + "add-v1-dee1622a.svg";